export default __webpack_public_path__ + "static/media/screen1.a486eab0.jpg";